// extracted by mini-css-extract-plugin
export default {"zoomModal":"K2-z"};